/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/no-unused-prop-types */
import cx from 'classnames';
import React, { useRef } from 'react';
import { getOnEnter } from '../../_utils';
import { Icon, IconColor, IconID, IconSize } from '../../icon';
import styles from './base.module.scss';
export var SwatchShapeOptions;
(function (SwatchShapeOptions) {
    SwatchShapeOptions["DEFAULT"] = "default";
    SwatchShapeOptions["ROUND"] = "round";
    SwatchShapeOptions["ROUND_LARGE"] = "round-large";
})(SwatchShapeOptions || (SwatchShapeOptions = {}));
export const BaseSelector = ({ title, disabled, onChange, hasGrayBackground, children, isToggle = false, isGradientEnabled = false, swatchShape = SwatchShapeOptions.DEFAULT, className, baseDivRef, tabIndex = 0, ariaLabel = '', customSelectHeaderClass = '', }) => {
    const dropDownHeaderRef = useRef(null);
    const refForBaseDiv = baseDivRef || dropDownHeaderRef;
    const onHeaderClick = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(refForBaseDiv, !isToggle);
        event.stopPropagation();
    };
    const selectContainerClass = cx(styles.select, styles.selectOpen, className, {
        [styles.roundedHead]: className === null || className === void 0 ? void 0 : className.includes('roundedHead'),
    });
    const selectHeaderClass = cx({
        [styles.selectHead]: swatchShape === 'default' || swatchShape === 'round-large',
        [styles.swatchRound]: swatchShape === SwatchShapeOptions.ROUND,
        [styles.selectOpen]: isToggle,
        [styles.disabled]: disabled,
        [styles.hasGrayBackground]: hasGrayBackground,
        [customSelectHeaderClass]: customSelectHeaderClass,
    });
    const selectCaretClass = cx(styles.selectCaret, { [styles.disabled]: disabled }, { [styles.selectOpen]: isToggle });
    const renderIcon = (iconName) => (React.createElement(Icon, { color: IconColor.GRAY, size: IconSize.MEDIUM, id: iconName }));
    return (React.createElement("div", { ref: refForBaseDiv, className: selectContainerClass, onClick: onHeaderClick, role: "button", tabIndex: tabIndex, onKeyDown: getOnEnter(onHeaderClick), "data-testid": "base-selector-container", "data-ts-element": "select-trigger", "aria-label": ariaLabel },
        title && (React.createElement("div", { className: isGradientEnabled ? '' : styles.title }, title)),
        swatchShape === SwatchShapeOptions.DEFAULT ||
            swatchShape === SwatchShapeOptions.ROUND_LARGE ? (React.createElement("div", { className: selectHeaderClass },
            children,
            React.createElement("div", { className: selectCaretClass }, isToggle
                ? renderIcon(IconID.CHEVRON_UP)
                : renderIcon(IconID.CHEVRON_DOWN)))) : (React.createElement("div", { className: selectHeaderClass }, children))));
};
//# sourceMappingURL=base-selector.js.map